{
  "version": 1,
  "asset_id": "b29d3ecb-6b3b-43b1-a701-c540b33e4c2c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/b29d3ecb-6b3b-43b1-a701-c540b33e4c2c/loc-cedar-park-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/b29d3ecb-6b3b-43b1-a701-c540b33e4c2c/loc-cedar-park-1280.webp",
  "original_filename": "loc-cedar-park-1280.webp",
  "size": 142628,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:20Z"
}
